<div class="paginator">
  <div class="page-size-selector section">
    {{'Show' | i18next}}
    <app-basic-dropdown [items]="pageSizeOptionsArray" [bindValue]="'id'" [bindLabel]="'name'" [searchable]="false"
      [model]="pageSize" (change)="onPageSizeChange($event)" [size]="'small'" [width]="'62px'" [showIcon]="false">
    </app-basic-dropdown>
    {{('Rows' | i18next).toLocaleLowerCase()}}
  </div>

  <div class="page-info section">
    {{'Rows' | i18next}} {{pageIndex * pageSize + 1}} - {{ Math.min((pageIndex + 1) * pageSize, length) }} {{'of' | i18next}} {{length}}
  </div>

  <div class="page-navigation-buttons section">
    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="onFirstPage()" [disabled]="pageIndex === 0"><i class="fal fa-chevron-double-left"></i></app-basic-button>
    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="onPreviousPage()"  [disabled]="pageIndex === 0"><i class="far fa-chevron-left"></i></app-basic-button>

    <app-basic-button *ngIf="pagesToShow?.length>0 && pagesToShow.indexOf(1) === -1" type="secondary" isIcon="true" size="medium" (click)="onFirstPage()"><span class="numbers">1</span></app-basic-button>
    <span class="dots" *ngIf="pagesToShow?.length>0 && pagesToShow.indexOf(1) === -1">...</span>

    <app-basic-button *ngFor="let pageN of pagesToShow" [type]="pageN==inputPageNumber ? 'primary' : 'secondary'" isIcon="true" size="medium" (click)="onPage(pageN)"><span class="numbers">{{pageN}}</span></app-basic-button>

    <span *ngIf="pagesToShow?.length>0 && pagesToShow.indexOf(Math.ceil(length / pageSize)) === -1" class="dots">...</span>
    <app-basic-button *ngIf="pagesToShow?.length>0 && pagesToShow.indexOf(Math.ceil(length / pageSize)) === -1" isIcon="true" type="secondary"  size="medium" (click)="onLastPage()"><span class="numbers">{{Math.ceil(length / pageSize) }}</span></app-basic-button>

      <app-basic-button type="secondary" isIcon="true" size="medium" (click)="onNextPage()" [disabled]="pageIndex === Math.ceil(length / pageSize) - 1"><i class="far fa-chevron-right"></i></app-basic-button>
    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="onLastPage()" [disabled]="pageIndex === Math.ceil(length / pageSize) - 1" ><i class="fal fa-chevron-double-right"></i></app-basic-button>
  </div>

  <div>
    {{('Go to' | i18next).toLocaleLowerCase()}}
    <app-basic-textbox [(model)]="inputPageNumber" size="medium" (keyup.enter)="onGoToPage()"
      [width]="'50px'"></app-basic-textbox>
  </div>
</div>
